<template>
  <sliding-modal
      :is-open="isOpen"
      @secondary="$emit('close')">
    <div class="CONTENTNEW">
      <div class="d-flex fd-row p-l-2 p-t-1">
        <div class ="INFORMATION-ICON">
          !
        </div>
        <div class="ta-center jc-center">
          <div class="text-bold text-lg p-b-1 p-t-1 p-l-1">
            Photo Upload Limit
          </div>
          <div class="TEXTBODY p-l-1">
            You can upload up to 8 photos at a time.
          </div>
        </div>
      </div>

      <button
          @click.prevent="$emit('close')"
          class="btn BUTTONCLASS"
          type="button">
        Okay
      </button>
    </div>
  </sliding-modal>
</template>

<script>
import SlidingModal from '@/views/Dashboard/components/SlidingModal';

export default {
  name: 'image-popup',
  components: {
    SlidingModal,
  },
  props: {
    isOpen: Boolean,
  },
};
</script>

  <style lang="scss" scoped>
    @import "~@homeservices/design-kit/tools";

    @import "~@/views/Dashboard/constants";

  .INFORMATION-ICON {
  display: flex;
  justify-content: center;
  align-items: baseline;
  line-height: 1;
  border: #3E7697 solid 3px;
  color: #3E7697;
  font-weight: 900;
  margin-top: 10px;

  @include circle(22px);
}
    .TEXTPHOTO {
        font-weight: 700;
        margin-left: 6px;
        font-size: 20px;
        color: black;
    }
    .CONTENTNEW{
        display: flex;
        flex-direction: column;
        background-color: white;
        justify-content: center;
        @include responsive(width, 95vw, $unit * 50);
        height: 180px;
    }
    .BODY-HEADER {

      width: 100%;

      font-weight: 700;
      background-color:  #F4F4F4;
      border-bottom: solid 1px $color-gray50;
    }
    /deep/ .CONTENT {
      padding:0px;
      max-width: 100%;
      max-height: 100%;
      overflow-y:auto;
    }
    /deep/ .FOOTER {
      background-color: white;
      border-top: solid 1px $color-gray50;
    }
    /deep/ x {
      border-bottom: solid 1px $color-gray50;
    }
    /deep/ .FIRE-TOAST {
        color: $color-red;
        border: 1px solid $color-red;
        background-color: $color-gray30;
    }
    .TEXTDISCLAIMER {
        font-size: 14px;
        font-weight: 400;
      }
      .TEXTBODY{
        font-size: 14px;
        color: #66686d;
      }
      .BUTTONCLASS{
        align-self: center;
        margin-top: 15px;
      }
  </style>
